import { render, staticRenderFns } from "./ModalAssignacioEnquesta.vue?vue&type=template&id=29c92c3e&"
import script from "./ModalAssignacioEnquesta.vue?vue&type=script&lang=js&"
export * from "./ModalAssignacioEnquesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports